import React, { Component } from 'react';
import { WithStyles, Grid, withStyles } from '@material-ui/core';
import { courseLandingPageStyles } from '../styles';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  AddCourseMileStone,
  NoContent,
  ViewPhase,
  //   CreateCourseType,
  CreateCoursePlan,
} from '../components/index';
import { HeadingComponent, CoursePlan, CombinedPhases } from '../components';
import { packageById } from '../mockData';
import {
  setGetPackageById, getListOfCourses,
  checkTreeDataValidation, cleanDataForPayload,
  hasEmptyWeeks,
}
  from './helpers';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contentManagementAction } from '../reducers/contentMangementData';
import { AddMilestone } from '../components/coursePlan/addMilestone';
import _ from 'lodash';
import AdvancedSettings from '../components/AdvancedSettings/AdvancedSettings';
import courseManagementServices from '../service/courseManagementServices';
import { createCoursePlanStatesAction } from '../reducers/createCoursePlanReducer';
import { contentManagementService } from '../service';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TabPanel from "../../userManagement/common/TabPanel";
import BasicInfo from '../components/BasicInfo/BasicInfo';
import { BasicInfoType } from '../types/enums/BasicInfoType';
import { createCoursePlanPayload, getPhaseStatus } from '../../course-Management/components/coursePlan/helpers/CoursePlanHelper';
import { showMsg } from '../../../../src/components/course/actions/loaderAlert';
import { setActiveTab, saveTabData, getBasicInfo, approveAndPublishCourse, rejectCourse } from "../actions/courseManagementActions";
import { CourseActiveTabs } from '../types/enums/CourseActiveTabs';
import { publishCourse } from '../actions/courseManagementActions';
import { setGoalsDataForTest } from '../components/coursePlan/helpers/goalsAndTest';
import { CourseBasicDetails } from '../types/interfaces/CourseBasicDetails';
import { getCreateCourseDefaultFormData, getRequestId } from '../helpers/helpers';
import { courseManagementActions } from '../reducers/courseManagementReducer';
import RequestStatus from './components/RequestStatus';
import { getPropertyValue, getQueryParams } from '../../../utils';
import HourAllocation from '../components/HourAllocation';
import { ACADEMIC_YEAR, DATA_TYPES } from '../../../constants/comman';
import cx from 'classnames';
import { MyPATDialog } from '../../common';
import { COURSE_VIEW_LIST, ENTITY_TYPE } from '../Constants/constants';

interface RouteParams {
  id?: string,
  type?: string;
}
interface CoursePlanLandingPageProps extends WithStyles<typeof courseLandingPageStyles>, RouteComponentProps<RouteParams> {
  classes: any;
  setPackageById: Function;
  setPackages: Function;
  getPackageByIdData: any;
  getPackages: any;
  match: any,
  treeData: any,
  setMergedComboCourse: any,
  selectedCourseData: any[],
  coursePlanResponse: any,
  setCoursePlanResponse: Function,
  setSelectedCourseData: Function,
  history: any,
  getBasicInfo: Function;
  basicInfo: any;
  setCoursePlanStates: Function;
  coursePlanState: any;
  setCourseSyllabus: Function;
  courseSyllabus: any;
  setChaptersSubject: Function;
  totalSubjectChapters: any;
  showMsg: Function;
  setActiveTab: Function;
  saveTabData: Function;
  activeTabFromProps: string;
  coursePlanDone: boolean;
  basicInfoDone: boolean;
  advancedSettingsDone: boolean;
  activeTabForCoursePlanLandingPage: number;
  basicInfoValid: boolean;
  advancedSettingsValid: boolean;
  publishCourse: Function;
  setTotalGoalsForComboCourse: Function;
  setScheduledTestData: Function;
  setActiveTabForCoursePlanLandingPage: Function;
  setIsTabOpen: Function;
  setPublishBtnClicked: Function;
  setIsCoursPlanTabAbleToPublish: Function;
  coursePlanMandatoryFlag: boolean;
  basicInfoMandatoryFlag: boolean;
  advancedSettingMandatoryFlag: boolean;
  isCoursPlanTabAbleToPublish: boolean;
  includesScheduledTests: boolean;
  setCourseBasicDetails: Function;
  basicDetails: any;
  setBasicInfo: Function;
  setSavedSuccessfully: (data: { key: string, value: boolean }) => void;
  resetToInitialState: () => void;
  savedSuccessfully: {
    advanceSettings: Boolean,
    coursePlan: Boolean,
    basicInfo: Boolean
  },
  setTreeData:Function,
  setPollingStatus: Function,
  approveAndPublishCourse: Function,
  rejectCourse: Function,
  revisedHours: any;
  phaseUploadUrl: any;
  setActiveCoursePlanView: any;
  activeCoursePlanViewList: any;
}
interface CoursePlanLandingPageState {
  activeComponent: string;
  coursePlanId: string,
  activeTab: any,
  requiredSaveButton?: boolean,
  finalResponse: any,
  isGoalCombo?: boolean,
  courseId: any,
  coursePlanDone: boolean;
  basicInfoDone: boolean;
  advancedSettingsDone: boolean;
  showMenuIcons: boolean;
  isCombo: boolean;
  basicInfoValid: boolean;
  advancedSettingsValid: boolean;
  isSearchQuery: boolean;
  coursePlanMandatoryFlag: boolean;
  basicInfoMandatoryFlag: boolean;
  advancedSettingMandatoryFlag: boolean;
  basicDetails: CourseBasicDetails;
  coursePlanViewModelVisible: boolean;
  activeCoursePlanView:string,
}

class CoursePlanLandingPage extends Component<CoursePlanLandingPageProps, CoursePlanLandingPageState> {
  constructor(props: CoursePlanLandingPageProps) {
    super(props);
    const {
      match: {
        params: { id },
      },
    } = this.props;


    // const packageData = contentManagementService.getPackageById(id).then((res: any) => {
    // const data = _.get(res,"responseObject.packageData",{})
    // console.log(data,"ashdkj")
    // return (data)
    // })

    


    this.state = {
      basicDetails: getCreateCourseDefaultFormData(),
      activeComponent: 'CoursePlan',
      coursePlanId: '',
      activeTab: 0,
      //requiredSaveButton: false,
      finalResponse: {},
      courseId: '',
      coursePlanDone: false,
      basicInfoDone: false,
      advancedSettingsDone: false,
      showMenuIcons: false,
      isCombo: false,
      basicInfoValid: true,
      advancedSettingsValid: false,
      isSearchQuery: false,
      coursePlanMandatoryFlag: false,
      basicInfoMandatoryFlag: false,
      advancedSettingMandatoryFlag: false,
      coursePlanViewModelVisible:false,
      activeCoursePlanView: ENTITY_TYPE.PHASE,
    };
  }
  componentDidMount() {
    this.loadCoursePlanContent();
    const {
      match: {
        params: { id = "" },
      },
    } = this.props;
    // this.props.getBasicInfo(id)
    //console.log('Package Data::::::::::', this.props.getPackageByIdData)
   
    contentManagementService.getPackageById(id).then((res: any) => {
      const packageData = _.get(res, "responseObject.packageData", {})
      this.setState({
        finalResponse: packageData,
        showMenuIcons:true,
      })
    })
    this.props.setIsTabOpen({booleanValue:false});

    // resetting the flags
    this.props.setSavedSuccessfully({ key: 'advanceSettings', value: false })
    this.props.setSavedSuccessfully({ key: 'basicInfo', value: false })
    this.props.setSavedSuccessfully({ key: 'coursePlan', value: false })
    this.setState({ activeCoursePlanView: COURSE_VIEW_LIST[this.props.activeCoursePlanViewList.length].key });
  };
  loadCoursePlanContent = () => {
    const { setPackageById, getPackageByIdData = {}, setPackages, setScheduledTestData, setBasicInfo } = this.props;
    // only for debug purpose in future it will be changed
    const query = new URLSearchParams(this.props.location.search);
    const masterId = query.get('masterId');
    const type = query.get('type');
    const {
      match: {
        params: { id },
      },
    } = this.props;
    const requestId = getRequestId();
    if (this.props.activeTabForCoursePlanLandingPage === 0) {
      this.props.setActiveTab(this.props.activeTabForCoursePlanLandingPage);
    }

    if (type === "version" && masterId) {
      contentManagementService.getPackageById(masterId).then((res: any) => {
        this.handleVersionSelect(res.responseObject.packageData)
      })
      contentManagementService.getPackageById(id).then((res: any) => {
        const packageData = _.get(res, "responseObject.packageData", {})
        this.setState({
          finalResponse: packageData,
          showMenuIcons:true,
        })
      })
    }
    

    setGetPackageById({ id, setPackageById, setPackages, setScheduledTestData, setBasicInfo, requestId }, this.renderDataForStandardCourse);
    if (this.props.match.path === '/course-Management/create-combo-course/:id/:type?') {
      id && setGoalsDataForTest(id, this.props.setTotalGoalsForComboCourse);
      this.setState({
        activeComponent: 'CreateCoursePlan',
        isGoalCombo: true,
          // this.props.match.params && this.props.match.params.type && this.props.match.params.type === 'Goals'
          //   ? true
          //   : false,
        isCombo: true
      });
    }
    //const query = new URLSearchParams(this.props.location.search);
    const coursePlanId = query.get('coursePlanId');

    if (coursePlanId) {
      this.handleOnSelect({ coursePlanId: { _id: coursePlanId } }, 'Version');
    }
    this.props.getBasicInfo(id)
    this.setState({
      courseId: id,
    });
  }

  componentDidUpdate(prevProps: CoursePlanLandingPageProps, prevState: CoursePlanLandingPageState) {
    if (prevProps.coursePlanDone !== this.props.coursePlanDone) {
      this.setState(
        {
          coursePlanDone: this.props.coursePlanDone,
        });
        if(prevProps.match.params!==this.props.match.params){
          this.setState({isGoalCombo: this.props.match.params && this.props.match.params.type === 'Goals' ? true : false});
        } 
    }

    if (prevProps.basicInfoDone !== this.props.basicInfoDone) {
      this.setState(
        {
          basicInfoDone: this.props.basicInfoDone,
        }
      );
    }

    if (prevProps.advancedSettingsDone !== this.props.advancedSettingsDone) {
      this.setState(
        {
          advancedSettingsDone: this.props.advancedSettingsDone,
        }
      );
    }

    if (prevProps.advancedSettingsValid !== this.props.advancedSettingsValid) {
      this.setState({
        advancedSettingsValid: this.props.advancedSettingsValid
      })
    }

    if (prevProps.basicInfoValid !== this.props.basicInfoValid) {
      this.setState({
        basicInfoValid: this.props.basicInfoValid
      })
    }
    if (prevState.isSearchQuery !== this.state.isSearchQuery) {
      const {
        match: {
          params: { id },
        },
        setPackageById,
        setPackages,
        setScheduledTestData
      } = this.props;
      // setGetPackageById({ id, setPackageById, setPackages, setScheduledTestData }, this.renderDataForStandardCourse);
    }

    if (prevProps.coursePlanMandatoryFlag !== this.props.coursePlanMandatoryFlag) {
      this.setState({
        coursePlanMandatoryFlag: this.props.coursePlanMandatoryFlag
      })
    }

    if (prevProps.basicInfoMandatoryFlag !== this.props.basicInfoMandatoryFlag) {
      this.setState({
        basicInfoMandatoryFlag: this.props.basicInfoMandatoryFlag
      })
    }

    if (prevProps.advancedSettingMandatoryFlag !== this.props.advancedSettingMandatoryFlag) {
      this.setState({
        advancedSettingMandatoryFlag: this.props.advancedSettingMandatoryFlag
      })
    }

    if (prevProps.basicInfo !== this.props.basicInfo) {

      this.props.setCourseBasicDetails(this.props.basicDetails)

    }
    if (prevState.finalResponse !== this.state.finalResponse) {
      //    debugger
    }

    if(prevProps.includesScheduledTests !== this.props.includesScheduledTests){

      const { treeData = {}, setIsCoursPlanTabAbleToPublish, includesScheduledTests } = this.props;
     // console.log({includesScheduledTests});
      let cloneTreeData = JSON.parse(JSON.stringify(treeData));
      const validateCoursePlanTab = checkTreeDataValidation(treeData, includesScheduledTests);
      setIsCoursPlanTabAbleToPublish({ booleanValue: validateCoursePlanTab });

    }
  }

  isReadyToPublishTheCoursePlan = () => {
    const { treeData = {} } = this.props;
    if (Object.keys(treeData).length) {
      return false;
    }
    return true;
    // return Object.keys(treeData).length ? false :true
    // if(prevProps.basicInfoValid !== this.props.basicInfoValid){
    //   this.setState({
    //     basicInfoValid: this.props.basicInfoValid
    //   }, () => console.log('::::::::basic info valid::::::',this.state.basicInfoValid))
    // }

    // if(prevProps.advancedSettingsValid !== this.props.advancedSettingsValid){
    //   this.setState({
    //     advancedSettingsValid: this.props.advancedSettingsValid
    //   }, () => console.log('::::::advanced settings valid:::::::', this.state.advancedSettingsValid))
    // }
    // console.log(this.props.basicInfo,"reducer")
  }

  // working on this as this funtion is not in used
  checkThisDataCoursePlanIsPublished = (coursePlanData: any) => {
    const { publishProcess = {} } = coursePlanData;

  }
  handleVersionSelect = (selectedData: any) => {

    const { setCoursePlanResponse } = this.props;
    const { coursePlanId } = selectedData;
    if (coursePlanId) {
      //courseplanid
      contentManagementService.getCousePlanApiById(coursePlanId, true).then(({ coursePlan }) => {
        this.updatePhaseStatus(coursePlan);
        this.setState({
          activeComponent: 'Selected'
        }, () => {
          setCoursePlanResponse({
            coursePlanResponse: coursePlan
          });
        })
      });
    }
  }
  // handler for pagination, search and pageSize
  handlePageChange = ({ newPage, searchQuery, pageSize }: any) => {
    const { getPackageByIdData, setPackages } = this.props;
    const { courseDetails = [], type = '' } = getPackageByIdData;
    const goals = _.map(courseDetails, 'courseId').join(',');
    let queryParams: any = {};
    if (newPage) {
      queryParams.pageNumber = String(newPage);
    }
    if (searchQuery) {
      queryParams.searchQuery = searchQuery;
    }
    if (pageSize) {
      queryParams.pageSize = pageSize;
    }
    queryParams.type = type;
    queryParams.goals = goals;
    getListOfCourses({ ...queryParams }, setPackages);
  };

  handleSaveCoursePlan = (callBack: any = "", forPublish?: boolean) => {
    // console.log(callBack, forPublish);
    const { treeData = {}, setCoursePlanResponse, setIsCoursPlanTabAbleToPublish, includesScheduledTests,getPackageByIdData } = this.props;
    let cloneTreeData = JSON.parse(JSON.stringify(treeData));
    const validateCoursePlanTab = checkTreeDataValidation(treeData, includesScheduledTests);
    setIsCoursPlanTabAbleToPublish({ booleanValue: validateCoursePlanTab });
    const { _id } = cloneTreeData;
     if((getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId === null) || (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId != null)){
      cloneTreeData.coursePlanId = getPackageByIdData.coursePlanId
      cloneTreeData.packageId =getPackageByIdData._id
    }else{
      cloneTreeData.coursePlanId = _id;
    }
    delete cloneTreeData._id;
    this.props.setSavedSuccessfully({ key: 'coursePlan', value: false }) // used for syncronising all tabs save to show single success popup
    return courseManagementServices.updateCoursePlan(cloneTreeData, this.props.revisedHours, this.props.phaseUploadUrl).then((response: any) => {
      if (this.props.match.params.type || this.props.match.params.hasOwnProperty('type')) {
        this.props.setMergedComboCourse(response.responseObject.coursePlan);
        this.setState({
          activeComponent: 'CreateCoursePlan',
          isGoalCombo: this.props.match.params && this.props.match.params.type === 'Goals' ? true : false,
        });
      } else {
        this.setState(
          {
            activeComponent: 'Selected',
          },
          () => {
            setCoursePlanResponse({
              coursePlanResponse: response.responseObject.coursePlan,
            });
          }
        );
      if(response.statusCode!= 422){ 
        const updatedAt=_.get(response,"responseObject.coursePlan.updatedAt",cloneTreeData.updatedAt);
        const newTreeData={...treeData};
        newTreeData.updatedAt=updatedAt;
        this.props.setTreeData({treeData:newTreeData});
       }
      }
      if(!forPublish) {
        this.props.setSavedSuccessfully({ key: 'coursePlan', value: true }) // used for syncronising all tabs save to show single success popup
      }

      if (typeof callBack === "function") {
        callBack();
      }
      
    });
    
  };

  handleSaveCreateCourse = async () => {
    const {
      setCoursePlanStates,
      totalSubjectChapters,
      setChaptersSubject,
      coursePlanState,
      setCoursePlanResponse,
      showMsg,
    } = this.props;
    let cloneTotalSubjectChapters: any = [...totalSubjectChapters];
    let cloneCoursePlanState: any = { ...coursePlanState };
    cloneCoursePlanState.status = 'draft';
    let returnData: any = await createCoursePlanPayload(this.props);
    if (returnData && returnData.statusCode === 200) {
      showMsg(returnData.responseMessage, 'success');
      //   this.setState({ isShowCombinedPhase: true });
      setCoursePlanResponse({ coursePlanResponse: { ...returnData.responseObject.coursePlan } });
    } else {
      showMsg(returnData.responseMessage, 'error');
      setCoursePlanStates({ coursePlanState: { ...cloneCoursePlanState } });
      setChaptersSubject({ totalSubjectChapters: [...cloneTotalSubjectChapters] });
    }
  };

  getSaveFunctionCallForAllTabs = (callBack: any = '', forPublish?: boolean,isVersion?:string) => {
    // console.log('IN SAVE FOR ALL')
      this.handleSaveCoursePlan(callBack, forPublish)
      .then(d => {
        this.props.saveTabData({ courseId: this.state.courseId,isVersion: isVersion?true:false });
      });
  }
  handleSaveForHeadingComponent = (callBack: any = "", forPublish?: boolean) => {
    this.props.setPollingStatus(true);
    return ((this.state.activeComponent === 'Selected' || this.state.activeComponent === 'CreateCoursePlan' ||
      (this.props.match.params.type || this.props.match.params.hasOwnProperty('type'))) && this.props.treeData._id) // do not save course plan when treeData does not have _id 
      ? this.getSaveFunctionCallForAllTabs(callBack, forPublish,this.props.getPackageByIdData.masterId)
      : this.props.saveTabData({ courseId: this.state.courseId,isVersion:this.state.basicDetails.masterId?true:false, showSuccessPopupOnComplete: true });
  };

  isSaveRequiredAccToActiveTab = () => {
    const { activeTabFromProps } = this.props;
    switch (activeTabFromProps) {
      case CourseActiveTabs.coursePlan:
        return false;
      case CourseActiveTabs.basicInfo:
        return true;
      case CourseActiveTabs.advancedSettings:
        return true;
    }
  };

  handlePublishCourse = () => {
    const requestId = getRequestId();
    const { treeData = {}, setCoursePlanResponse, getPackageByIdData, history } = this.props;
    if (requestId) {
      this.props.approveAndPublishCourse({ requestId, packageId: getPackageByIdData._id });
      return;
    }

    let cloneTreeData = JSON.parse(JSON.stringify(treeData));
    let phasesWithEmptyWeeks: string[] = [];
    //  phasesWithEmptyWeeks = hasEmptyWeeks(cloneTreeData.phases)
    if(phasesWithEmptyWeeks && !phasesWithEmptyWeeks.length){ 
    const { _id } = cloneTreeData;
    const { status = '' } = getPackageByIdData;
    if((getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId === null) || (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId != null)){
      cloneTreeData.coursePlanId = getPackageByIdData.coursePlanId
      cloneTreeData.packageId =getPackageByIdData._id
    }else{
      cloneTreeData.coursePlanId = _id;
    }
    cloneTreeData.status = 'published';
    const master = getPackageByIdData.masterId;
    delete cloneTreeData._id;
    const version = this.props.getPackageByIdData.masterId;
      this.props.saveTabData({ 
        courseId: this.state.courseId,
        isVersion:version?true:false, 
        showSuccessPopupOnComplete: false,
        saveCoursePlan: true,
        coursePlanApiPayload: cloneTreeData,
        toPublish: true,
        master,
        proceedRequest: false,
      });
    
    // courseManagementServices.updateCoursePlan(cloneTreeData).then((response: any) => {
    //   const { courseId } = this.state;
    //   const { savedSuccessfully } = this.props;
    //   setTimeout(() => {
    //     if(savedSuccessfully.basicInfo && (version || savedSuccessfully.advanceSettings) && response.statusCode === 200) {
    //       this.props.publishCourse(master?{id: courseId,masterId: master}:{id: courseId});
    //       this.props.setPublishBtnClicked(true);
    //       this.props.resetToInitialState();
    //       // window.location.reload()
    //       setTimeout(() =>  history.push(`/course-Management`), 250);
    //     }
    //   }, 2000);

    // });

    // if (status.toLowerCase() === 'published') {
    //   this.handleSaveForHeadingComponent(() => {}, true)
    // }
  } else{
     phasesWithEmptyWeeks.length && this.props.showMsg(`Week(s) of ${phasesWithEmptyWeeks.join(',')} does not contain any content`, 'error');
    
  }

  };

  handleIsSearchQueryTouched = (isSearchTouched: boolean) => {
    this.setState({
      isSearchQuery: isSearchTouched,
    })
  }

  renderHeadingComponent = () => {
    const { getPackageByIdData, activeTabFromProps, isCoursPlanTabAbleToPublish } = this.props;
    const { name = '', status = '' } = getPackageByIdData;
    const {
      coursePlanDone,
      basicInfoDone,
      advancedSettingsDone,
      basicInfoValid,
      advancedSettingsValid,
      basicInfoMandatoryFlag,
      advancedSettingMandatoryFlag,
      coursePlanMandatoryFlag,
      isGoalCombo
    } = this.state;
     //  const flagSet = advanceSettingFlagNeeded?
   // console.log('::::::::::::CHECK::::::::::::::::::::',{basicInfoMandatoryFlag}, {advancedSettingMandatoryFlag}, {isCoursPlanTabAbleToPublish})
    // console.log('::::::::::::isCoursPlanTabAbleToPublish::::::::::::::::::::',isCoursPlanTabAbleToPublish)
    //after consulting with vinod succsessive we have remove a check of basic info fla as it was not needed to be checked all time
    let isCoursePlanId = window.location.href.includes('coursePlanId'); // coursePlanId includes means page open from coursePlanPreview page
    let canPublishCourse = (isCoursePlanId === false && status.toLowerCase() === 'published' )?false:((advancedSettingMandatoryFlag && isCoursPlanTabAbleToPublish) || status.toLowerCase() === 'published');
   // console.log({isCoursePlanId});
    
    return <HeadingComponent
      name={name}
      status={status}
      handleSave={
        this.handleSaveForHeadingComponent
      }
      match={this.props.match}
      history={this.props.history}
      activeComponent={this.state.activeComponent}
      hideSave={status.toLowerCase() === 'published'}
      isSaveRequiredFromProps={this.isSaveRequiredAccToActiveTab()}
      handlePublish={this.handlePublishCourse}
      coursePlanDone={coursePlanDone}
      basicInfoDone={basicInfoDone}
      advancedSettingsDone={advancedSettingsDone}
      hidePublish={false}
      basicInfoValid={basicInfoValid}
      advancedSettingsValid={advancedSettingsValid}
      activeTab={activeTabFromProps}
      handleComponentSwitching={this.handleComponentSwitching}
      handleTabSwitch={this.handleTabSwitch}
      isGoalCombo={isGoalCombo}
      canPublishCourse={canPublishCourse}
      hideDuplicate={true}
    />;
    
  };
  handleComponentSwitching = (componentValue: string, id?: string) => {
    this.setState(() => ({
      activeComponent: componentValue,
      coursePlanId: id ? id : '',
    }));
  };


  createPayloadDataForCreateApi = (response: any, ) => {
    const { getPackageByIdData: { _id, startDate, expiryDate } } = this.props;
    let cloneCoursePlanData = JSON.parse(JSON.stringify(response));
    cloneCoursePlanData.packageId = _id;
    cloneCoursePlanData.startDate = startDate;
    cloneCoursePlanData.endDate = expiryDate;
    cloneCoursePlanData = {
      ...cloneCoursePlanData,
      phases: JSON.parse(JSON.stringify(cleanDataForPayload(cloneCoursePlanData.phases)))
    }
    return cloneCoursePlanData;
  };

  renderDataForStandardCourse = (coursePlanId: string) => {
   // console.log(':::::::::::CheckThisPage:::::::::::::::::::::::');
   const { setCoursePlanResponse } = this.props;
    contentManagementService.getCousePlanApiById(coursePlanId, true).then(({ coursePlan }) => {
      this.updatePhaseStatus(coursePlan);
      coursePlan.type !== 'combo' && this.setState(
        {
          activeComponent: 'Selected',
        },
        () => {
          setCoursePlanResponse({
            coursePlanResponse: coursePlan,
          });
        });
    });
  }

  getDateFormat = (date: string) => {
    return new Date(date);
  }
  validatePhases = (phases: any, packageStartDate: any, packageExpiryDate: any) => {
    const phasesLength = phases.length - 1;
    let startDate = '';
    let endDate = '';
    if (phasesLength === 0) {
      startDate = phases[0].startDate;
      endDate = phases[0].startDate
    } else {
      startDate = phases[0].startDate;
      endDate = phases[phasesLength].endDate;
    }
   // console.log({ startDate, endDate, packageStartDate, packageExpiryDate });
    if (this.getDateFormat(packageStartDate) <= this.getDateFormat(startDate) &&
      this.getDateFormat(packageExpiryDate) >= this.getDateFormat(endDate)) {
      return true;
    }
    return false
  }
  handleOnSelect = (selectedData: any, version?: String) => {
    const { setCoursePlanResponse, getPackageByIdData: { _id: packageDataId = '', startDate = '', expiryDate = '' } } = this.props;
    const { coursePlanId } = selectedData;
    //console.log({ selectedData })
    if (coursePlanId) {
      const { _id = '' } = coursePlanId;
      //courseplanid
     // console.log(':::::::::::::::::::::::Calling::::::::::::::::::::::::::::::::::');
      contentManagementService.getCousePlanApiById(_id, true).then(({coursePlan}) => {
        this.updatePhaseStatus(coursePlan);
        if (packageDataId !== coursePlan.packageId) {
          const payload = this.createPayloadDataForCreateApi(coursePlan);
          const validatePhases = this.validatePhases(coursePlan.phases, startDate, expiryDate);
          if (validatePhases) {
            courseManagementServices.createCoursePlan(payload).then((postData: any) => {
              this.setState(
                {
                  activeComponent: 'Selected',
                },
                () => {
                  setCoursePlanResponse({
                    coursePlanResponse: postData.responseObject.coursePlan,
                  });
                }
              );
            });
          } else {
            if (!version) {
              this.props.showMsg('This course plan does not align with the new course duration', 'error')
            }
          }

        } else {
          this.setState(
            {
              activeComponent: 'Selected',
            },
            () => {
              setCoursePlanResponse({
                coursePlanResponse: coursePlan,
              });
            });
        }
      });
    }
  };

  renderStandardComboComponent = () => {
    return (<>
      <RequestStatus />
      {this.renderCoursePlanTabComponents()}
    </>);
  }

  renderCoursePlanTabComponents = () => {
    const { activeComponent = '', coursePlanId, isGoalCombo, finalResponse } = this.state;
    const { getPackages = {}, classes, treeData = {}, coursePlanResponse, match,getPackageByIdData } = this.props;
    const { packages = [], totalPages, pageNumber } = getPackages;
    const query = this.props.location.search;
    const isVersion = query.split('=')[query.split('=').length - 1] === 'version' ? true : false;
    const isEditingCourse = query.split("editingCourse=")
    // const isPublishedCourse = isEditingCourse[1]=== "true" && getPackageByIdData.coursePlanId !=null && getPackageByIdData.masterId === null
    const isPublishedVersion =isEditingCourse[1]=== "true" && (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId === null) || (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId != null); 
    switch (activeComponent) {
      case 'CoursePlan':
        return (
          <CoursePlan
            content={packages}
            totalPages={totalPages}
            pageNumber={pageNumber}
            handlePageChange={this.handlePageChange}
            handleComponentSwitching={this.handleComponentSwitching}
            handleOnSelect={this.handleOnSelect}
            courseData={treeData}
            match={this.props.match}
            handleIsSearchQueryTouched={this.handleIsSearchQueryTouched}
            isSearchQuery={this.state.isSearchQuery}
          />
        );
      case 'CreateCoursePlan':
        return (
          <CreateCoursePlan
            classes={classes}
            match={this.props.match}
            history={this.props.history}
            isGoalCombo={isGoalCombo}
            phaseAlignmentResponse={finalResponse.phaseAlignment}
            handleComponentSwitching={this.handleComponentSwitching}
          />
        );
      case 'View':
        return <ViewPhase history={this.props.history} match={this.props.match} coursePlanId={coursePlanId} handleOnSelect={this.handleOnSelect} content={packages} />;
      case 'Selected':{
        return <CombinedPhases data={coursePlanResponse} phaseAlignmentResponse={isPublishedVersion?finalResponse.phaseAlignment:""} match={this.props.match} isVersion={isVersion} fromCombo={isGoalCombo}/>;
      }
    }
  };

  handleTabSwitch = (event: any, newValue: any) => {
    const { setActiveTabForCoursePlanLandingPage } = this.props;
    setActiveTabForCoursePlanLandingPage({
      activeTabForCoursePlanLandingPage: newValue,
    });
    this.props.setActiveTab(newValue);
  };

  updatePhaseStatus(coursePlan: any): void {
    (coursePlan && coursePlan.phases) && (
      coursePlan.phases.forEach((phase: any) => {
        if (typeof phase.isActive !== DATA_TYPES.BOOLEAN) {
          const { startDate = '', endDate = '' } = phase;
          phase.isActive = getPhaseStatus(startDate, endDate);
        }
      })
    );
  }

  renderNoContent = () => {
    const { isSearchQuery } = this.state;
    const { getPackages = {}, treeData = {} } = this.props;
    const { packages = [], totalPages, pageNumber } = getPackages;
    if (packages && !packages.length && !isSearchQuery) {
      return <NoContent match={this.props.match} history={this.props.history} />
    } else {
      return (
        <CoursePlan
          content={packages}
          totalPages={totalPages}
          pageNumber={pageNumber}
          handlePageChange={this.handlePageChange}
          handleComponentSwitching={this.handleComponentSwitching}
          handleOnSelect={this.handleOnSelect}
          courseData={treeData}
          match={this.props.match}
          handleIsSearchQueryTouched={this.handleIsSearchQueryTouched}
          isSearchQuery={this.state.isSearchQuery}
        />
      )

    }
  }
  a11yProps = (index: any) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  renderTabs = () => {
    const { classes, getPackageByIdData, getPackages, activeTabForCoursePlanLandingPage, match, coursePlanResponse } = this.props;
    const { coursePlanId, masterId } = getPackageByIdData;
    const { packages = [] } = getPackages;
    const { activeTab, isGoalCombo, isCombo, finalResponse } = this.state;
    const {
      match: {
        params: { type },
      },
    } = this.props;
    const packageType = type && type === "version" ? true : false
   // console.log({ getPackageByIdData });
   const disableAdvanceSetting = (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId === null) || (getPackageByIdData.masterId !=null && getPackageByIdData.coursePlanId != null);
   return (
      <Grid className={classes.tabContainer}>
        {/* <div className={classes.root}> */}
        {/* <AppBar position="static"> */}
        <Tabs
          classes={{ indicator: classes.indicatorColorStyle }}
          value={activeTabForCoursePlanLandingPage}
          onChange={this.handleTabSwitch}
          aria-label='simple tabs example'
        >
          <Tab
            label='Course Plan'
            {...this.a11yProps(0)}
            className={activeTabForCoursePlanLandingPage === 0 ? classes.active_tab : classes.default_tabStyle}
          />
          <Tab
            label='Basic Info'
            {...this.a11yProps(1)}
            className={activeTabForCoursePlanLandingPage === 1 ? classes.active_tab : classes.default_tabStyle}
          />
          <Tab
            label='Advance Setting'
            {...this.a11yProps(2)}
            className={activeTabForCoursePlanLandingPage === 2 ? classes.active_tab : classes.default_tabStyle}
          />
          <Tab
            label='Hours Allocation'
            {...this.a11yProps(3)}
            className={activeTabForCoursePlanLandingPage === 3 ? classes.active_tab : classes.default_tabStyle}
          />
        </Tabs>
        <TabPanel value={activeTabForCoursePlanLandingPage} index={0} unmountOnExit={false}>
          <Grid className={classes.tabArea}>
            {!isCombo && (
              <>
                {/* {this.renderCoursePlanTabComponents()} */}
                {((packages && packages.length) || coursePlanId) ? (
                  this.renderStandardComboComponent()
                ) : (
                    this.renderNoContent()
                  )}
              </>
            )}
            {isCombo && this.renderStandardComboComponent()}
            {/* <CreateCoursePlan classes={classes} match={this.props.match} history={this.props.history} /> */}
          </Grid>
        </TabPanel>
        <TabPanel className={classes.tabAreaContainer} value={activeTabForCoursePlanLandingPage} index={1}
          unmountOnExit={false}
        >
          <Grid className={classes.tabArea}>
            {/* {
             !_.isEmpty(finalResponse) &&
             ( */}
            <BasicInfo
              basicInfoType={isCombo ? BasicInfoType.comboCourse : BasicInfoType.standard}
              match={this.props.match}
              showMenuIcon={disableAdvanceSetting === true?true:false}
              finalResponse={finalResponse}
              coursePlanResponse={coursePlanResponse}
              basicInfo={getPackageByIdData}
              editMode={true}
            />
        {/* )
           }  */}


          </Grid>
        </TabPanel>
        <TabPanel className={classes.tabAreaContainer} value={activeTabForCoursePlanLandingPage} index={2} unmountOnExit={false}>
          <Grid className={classes.tabArea}>
            {/* add yourcomponent here */}
            <AdvancedSettings
             match={this.props.match}
              isPreview={disableAdvanceSetting === true?true:false}
             />
            {/* <CreateCourseType/> */}
            {/* <CombinedPhases /> */}
          </Grid>
        </TabPanel>
        <TabPanel className={classes.tabAreaContainer} value={activeTabForCoursePlanLandingPage} index={3} unmountOnExit={false}>
          <Grid className={classes.tabArea}>
            <HourAllocation
              isPreview={false} //TODO make it dynamic
            />
          </Grid>
        </TabPanel>
        {/* </div> */}
       {!activeTabForCoursePlanLandingPage && <button onClick={this.toggleCoursePlanViewModal} className={classes.planSummary}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
         <g id="ic:sharp-calendar-view-day">
           <path id="Vector" d="M2 11.1207H14V12.5H8H2V11.1207ZM2 6.25862H14V9.74138H2V6.25862ZM2 3.5H14V4.87931H2V3.5Z" fill="#1D7DEA" />
         </g>
       </svg> Plan Summary
       </button>}
      </Grid>
    );
  };

  toggleCoursePlanViewModal = () => {
    this.setState({ coursePlanViewModelVisible: !this.state.coursePlanViewModelVisible });
  }

  handleCoursePlanView = (activeCoursePlanView: string) => {
    let viewList: string[];
    switch (activeCoursePlanView) {
      case ENTITY_TYPE.WEEK:
        viewList = [ENTITY_TYPE.PHASE];
        break;
      case ENTITY_TYPE.CHAPTER:
        viewList = [ENTITY_TYPE.PHASE, ENTITY_TYPE.WEEK];
        break;
      default:
        viewList = [];
        break;
    }
    this.toggleCoursePlanViewModal();
    this.setState({ activeCoursePlanView });
    this.props.setActiveCoursePlanView(viewList);
  }

  render() {
    const { getPackageByIdData, getPackages, classes } = this.props;
    const { coursePlanId } = getPackageByIdData;
    const { packages = [] } = getPackages;
    const { finalResponse, coursePlanViewModelVisible, activeCoursePlanView } = this.state
    return (
      <>
        {/*  {Object.keys(getPackages).length > 0 && packages && packages.length ? */}

        {this.renderHeadingComponent()}
        {this.renderTabs()}
        <MyPATDialog
          dialogOpen={coursePlanViewModelVisible}
          onDialogClose={this.toggleCoursePlanViewModal}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: 'sm',
          }}
        >
          <Grid container justify="center" className={classes.selectViewContainer}>
            <img className={classes.close} src="/assets/img/closeIcon.svg" alt="Close" onClick={this.toggleCoursePlanViewModal} />
            <Grid item xs={12} className={classes.selectImg}>
              <img src="/assets/img/select-view.svg" alt="Select View" />
            </Grid>
            <Grid item xs={12}>
              <h1 className={classes.headingText}>Select View</h1>
            </Grid>
            <p className={classes.paraText}>Information will be displayed based on the option selected</p>
            <ul className={classes.viewList}>
              {COURSE_VIEW_LIST.map(view => <li className={cx({ 'active': activeCoursePlanView === view.key })}
                onClick={() => this.handleCoursePlanView(view.key)} key={view.key}>{view.label}</li>)}
            </ul>
          </Grid>
        </MyPATDialog>
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    getPackageByIdData: _.get(state, 'courseMangementData.contentManagementData.packageByIdData.packageData', {}),
    coursePlanResponse: _.get(state, 'createCoursePlanStates.coursePlanResponse', {}),
    getPackages: _.get(state, 'courseMangementData.contentManagementData.packages', {}),
    treeData: _.get(state, 'courseMangementData.contentManagementData.treeData', {}),
    selectedCourseData: _.get(state, 'courseMangementData.contentManagementData.selectedCourseData', []),
    activeTabForCoursePlanLandingPage: _.get(
      state,
      'courseMangementData.contentManagementData.activeTabForCoursePlanLandingPage',
      []
    ),
    addedChapterCount: state.createCoursePlanStates.addedChapterCount,
    courseSyllabus: state.createCoursePlanStates.courseSyllabus,
    totalSubjectChapters: state.createCoursePlanStates.totalSubjectChapters,
    coursePlanState: state.createCoursePlanStates.coursePlanState,
    phases: state.createCoursePlanStates.phases,
    activeTabFromProps: state.courseMangementData.contentManagementData.activeTab,
    coursePlanDone: state.courseMangementData.contentManagementData.coursePlanDone,
    //basicInfo: state.courseMangementData.courseManagementReducer.courseBasicDetails,
    basicInfoDone: state.courseMangementData.contentManagementData.basicInfoDone,
    advancedSettingsDone: state.courseMangementData.contentManagementData.advancedSettingsDone,
    basicInfoValid: state.courseMangementData.contentManagementData.basicInfoValid,
    advancedSettingsValid: state.courseMangementData.contentManagementData.advancedSettingsValid,
    coursePlanMandatoryFlag: state.courseMangementData.contentManagementData.coursePlanMandatoryFlag,
    basicInfoMandatoryFlag: state.courseMangementData.contentManagementData.basicInfoMandatoryFlag,
    advancedSettingMandatoryFlag: state.courseMangementData.contentManagementData.advancedSettingMandatoryFlag,
    isCoursPlanTabAbleToPublish: _.get(state, 'courseMangementData.contentManagementData.isCoursPlanTabAbleToPublish', false),
    includesScheduledTests: _.get(state, 'courseMangementData.contentManagementData.includesScheduledTests', true),
    basicInfo: state.courseMangementData.courseManagementReducer.basicInfo,
    savedSuccessfully: state.courseMangementData.courseManagementReducer.savedSuccessfully,
    revisedHours: state.courseMangementData.contentManagementData.revisedHours,
    phaseUploadUrl: state.courseMangementData.contentManagementData.phaseUploadUrl,
    activeCoursePlanViewList: getPropertyValue(state, 'courseMangementData.contentManagementData.activeCoursePlanViewList', []),
  };
};
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getBasicInfo: getBasicInfo,
      setPackageById: contentManagementAction.setPackageById,
      setPackages: contentManagementAction.setPackages,
      setSelectedCourseData: contentManagementAction.setSelectedCourseData,
      setCoursePlanResponse: createCoursePlanStatesAction.setCoursePlanResponse,
      showMsg: showMsg,
      setChaptersSubject: createCoursePlanStatesAction.setChaptersSubject,
      setCoursePlanStates: createCoursePlanStatesAction.setCoursePlanStates,
      setMergedComboCourse: contentManagementAction.setMergedComboCourse,
      setActiveTab: setActiveTab,
      saveTabData: saveTabData,
      publishCourse: publishCourse,
      approveAndPublishCourse,
      rejectCourse,
      setTotalGoalsForComboCourse: contentManagementAction.setTotalGoalsForComboCourse,
      setScheduledTestData: contentManagementAction.setScheduledTestData,
      setActiveTabForCoursePlanLandingPage: contentManagementAction.setActiveTabForCoursePlanLandingPage,
      setIsTabOpen: contentManagementAction.setIsTabOpen,
      setPublishBtnClicked: contentManagementAction.setPublishBtnClicked,
      setIsCoursPlanTabAbleToPublish: contentManagementAction.setIsCoursPlanTabAbleToPublish,
      setCourseBasicDetails: courseManagementActions.setCourseBasicDetails,
      setBasicInfo: courseManagementActions.setBasicInfo,
      resetToInitialState: courseManagementActions.resetToInitialState,
      setSavedSuccessfully: courseManagementActions.setSavedSuccessfully,
      setTreeData: contentManagementAction.setTreeData,
      setPollingStatus: courseManagementActions.setPollingStatus,
      setActiveCoursePlanView: contentManagementAction.setActiveCoursePlanView
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(courseLandingPageStyles)(withRouter(CoursePlanLandingPage)));
